import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withSnackbar } from 'notistack';

import LoadingButton from '../../Buttons/Loading';

const SingleTextFieldDialog = ({
  label,
  onClose,
  onSubmit,
  submitLabel = 'Save',
  cancelLabel = 'Close',
  isOpen,
  inputLabel,
  startingValue,
  onSuccess,
  enqueueSnackbar
}) => {
  const [value, setValue] = useState(startingValue !== undefined ? startingValue : '');
  const [loading, setLoading] = useState(false);

  useEffect(
    () => {
      if (!isOpen) {
        setValue(startingValue !== undefined ? startingValue : '');
      }
    },
    [startingValue]
  );
  
  const onSubmitClick = async () => {
    setLoading(true);
    try {
      const response = await onSubmit(value);
      setLoading(false);
      onSuccess(response);
    } catch (e) {
      setLoading(false);
      enqueueSnackbar(e, { variant: 'error' });
    }
  };

  const resetInput = () => {
    setValue(startingValue !== undefined ? startingValue : '');
  };

  return (
    <Dialog maxWidth='sm' fullWidth open={isOpen} onClose={onClose} onExited={resetInput}>
      <DialogTitle>{label}</DialogTitle>
      <DialogContent>
        <TextField
          label={inputLabel}
          onChange={e => setValue(e.target.value)}
          fullWidth
          value={value}
          variant='outlined'
          disabled={loading}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color='primary'>{cancelLabel}</Button>
        <LoadingButton
          isLoading={loading}
          disabled={value.length === 0}
          onClick={onSubmitClick} color='primary'
        >
          {submitLabel}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
};

export default withSnackbar(SingleTextFieldDialog);